import * as types from '../../action-types';

export default () => ({
  type: types.CLEAR_GIFTCARD_FORM,
});
